// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + (chunkId === "354" ? "lib-axios" : chunkId) + "." + {"354": "abcfb325","422": "c9c02f20","495": "664f3fd9","528": "e087e730","710": "69e17f87","729": "8f5ce218",}[chunkId] + ".js"
}